import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "ph_barnGrooveSize" }, "Barn Groove Size:", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "form-group text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "ph_barnGrooveQuantity" }, "Quantity:", -1)
const _hoisted_6 = {
  key: 0,
  class: "form-group text-left"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "ph_barnGrooveSize" }, "Width (inches):", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 1,
  class: "form-group text-left"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "ph_barnGrooveSize" }, "Depth (inches):", -1)
const _hoisted_11 = ["value"]

import { PreHangOption } from "@/types/preHang";
    import { BarnGroove } from '@/services/prehang-classes/ph-barn-groove';
    import { ref, onMounted, watch } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BarnGroove',
  props: {
        barnGroove: { type: BarnGroove, required: true }
    },
  emits: ['updatePh'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

    const type = ref<'standard'|'custom'>('standard')
    const width = ref<string>('')
    const depth = ref<string>('')
    const qty = ref<number>(0)

    const widthOptions = ref<PreHangOption[]>([])
    const depthOptions = ref<PreHangOption[]>([])

    watch(qty, () => {
        props.barnGroove.updateQuantity(qty.value)
        emits('updatePh')
    })

    watch(type, () => {
        updateBarnGrooveSize()
    })
    watch(width, () => {
        updateBarnGrooveSize()
    })
    watch(depth, () => {
        updateBarnGrooveSize()
    })
    
    function updateBarnGrooveSize() {
        const size = {
            type: type.value,
            width: '1/4',
            depth: '3/4'
        }
        if(type.value == 'custom') {
            size.width = width.value
            size.depth = depth.value
        }

        props.barnGroove.updateSize(size)
        if(props.barnGroove.quantity > 0) {
            emits('updatePh')
        }
    }

    onMounted(() => {
        widthOptions.value = props.barnGroove.getWidthOptions()
        depthOptions.value = props.barnGroove.getDepthOptions()
        type.value = props.barnGroove.type || 'standard'
        width.value = props.barnGroove.width || widthOptions.value[0].name
        depth.value = props.barnGroove.depth || depthOptions.value[0].name
        qty.value = props.barnGroove.quantity || 0
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("select", {
        id: "ph_barnGrooveSize",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((type).value = $event)),
        class: "form-select form-select-sm mb-3"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.barnGroove.getSizeOptions(), (size) => {
          return (_openBlock(), _createElementBlock("option", {
            key: size.value,
            value: size.value
          }, _toDisplayString(size.label), 9, _hoisted_3))
        }), 128))
      ], 512), [
        [_vModelSelect, type.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        id: "ph_barnGrooveQuantity",
        type: "number",
        max: "100",
        min: "0",
        step: "1",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((qty).value = $event)),
        class: "form-control mb-3"
      }, null, 512), [
        [_vModelText, qty.value]
      ])
    ]),
    (type.value == 'custom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("select", {
            id: "ph_barnGrooveSize",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((width).value = $event)),
            class: "form-select form-select-sm mb-3"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(widthOptions.value, (width) => {
              return (_openBlock(), _createElementBlock("option", {
                key: width.id,
                value: width.name
              }, _toDisplayString(width.name), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, width.value]
          ])
        ]))
      : _createCommentVNode("", true),
    (type.value == 'custom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("select", {
            id: "ph_barnGrooveSize",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((depth).value = $event)),
            class: "form-select form-select-sm mb-3"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(depthOptions.value, (depth) => {
              return (_openBlock(), _createElementBlock("option", {
                key: depth.id,
                value: depth.name
              }, _toDisplayString(depth.name), 9, _hoisted_11))
            }), 128))
          ], 512), [
            [_vModelSelect, depth.value]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})